import httpClient from "../http/http-client";
import { IAssumption, IPostAssumption, IRegisterResponse } from './assumption.model';

export default class AssumptionService {
  http;

  constructor() {
    this.http = httpClient
  }

  async getAll(queryString?: string): Promise<IAssumption[]> {
    return this.http.get(`assumption${queryString ? queryString : ''}`)
      .then(response => {
        return response.data.rows
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async getAllWithPagination(page: number, perPage: number = 10, orderBy?: string, order?: 'asc' | 'desc', reportPeriodId?: string): Promise<{ count: number, rows: IAssumption[] }> {
    return this.http.get(`assumption?page=${page}&perPage=${perPage}${order && orderBy ? `&orderBy=${orderBy}&order=${order}` : ''}${reportPeriodId ? `&reportPeriodId=${reportPeriodId}` : ''}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err;
      });
  }

  async getAllForGroupWithPagination(groupId: string, page: number, perPage: number = 10, orderBy?: string, order?: 'asc' | 'desc', reportPeriodId?: string): Promise<{ count: number, rows: IAssumption[] }> {
    return this.http.get(`assumption?groupId=${groupId}&page=${page}&perPage=${perPage}${order && orderBy ? `&orderBy=${orderBy}&order=${order}` : ''}${reportPeriodId ? `&reportPeriodId=${reportPeriodId}` : ''}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err;
      });
  }


  /**
   * The assumptions register for a period exactly as the reports print it (assumptions, then
   * acknowledged readiness findings, then disclosed estimate notes), with each entry's source and
   * link. With a group: that group's assumptions and the period notes written on its page.
   */
  async getRegister(reportPeriodId: string, groupId?: string): Promise<IRegisterResponse> {
    const query = new URLSearchParams({ reportPeriodId })
    if (groupId) query.set('groupId', groupId)
    return this.http.get(`assumption/register?${query.toString()}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async getOne(assumptionId: string): Promise<IAssumption> {
    return this.http.get(`assumption/${assumptionId}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async create(assumption: IPostAssumption): Promise<IAssumption> {
    return this.http.post(`assumption`, assumption)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async update(assumptionId: string, assumption: IPostAssumption): Promise<IAssumption> {
    return this.http.patch(`assumption/${assumptionId}`, assumption)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async clone(assumptionId: string, reportPeriodIds: string[]): Promise<{ success: boolean, message: string, clones: IAssumption[] }> {
    return this.http.post(`assumption/${assumptionId}/clone`, { reportPeriodIds })
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  // Answers once the row is deleted ({ message }); a 404 for an id that is not this organisation's.
  async remove(assumptionId: string): Promise<{ message: string }> {
    return this.http.delete(`assumption/${assumptionId}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }
}